import { AccreditationStatus, InvestorAccount } from '@services/appsync/types';

export function getInitialAccreditationState(investor: InvestorAccount | null) {
  return {
    certification: Boolean(investor?.accreditation_self?.reason_certification),
    employment: Boolean(investor?.accreditation_self?.reason_employment),
    income: Boolean(investor?.accreditation_self?.reason_annual_income),
    netWorth: Boolean(investor?.accreditation_self?.reason_net_worth),
    none: investor?.accreditation_self?.status === AccreditationStatus.REJECTED,
  };
}
